import { Injectable } from '@angular/core';
import { API } from './api.service';
import { ES } from './es.service';
import * as _ from 'lodash';

@Injectable()
export class ArtistService {
    constructor(private api: API, private es: ES) {

    }

    public getArtistDetailsBySlug(slug: string) {
        return this.api.get('artists/by-slug/' + slug);
    }

    public getArtistTracks(page: any, artistId = false) {
        let url = 'artists/tracks?offset=' + page;
        if (artistId === false) {
            artistId = null;
        } else {
            url += '&artistId=' + artistId;
        }
        return this.api.get(url);
    }

    public loadFollowers(page: any, artistId = false) {
        let url = 'artists/followers?offset=' + page;
        if (artistId === false) {
            artistId = null;
        } else {
            url += '&artistId=' + artistId;
        }
        return this.api.get(url);
    }

    public getArtistsForSearch(queryString: string, pageParams: any) {
        let options = this.es.setCriteria({}, 'artist', pageParams, queryString);
        return this.es.listing(options).then((body) => {
            let hits = body.hits.hits;
            return _.keys(_.groupBy(hits, '_id'));
        });
    }

    public getArtistsByIds(artistIds) {
        let queryParams = '';
        artistIds.forEach(function (arrayItem) {
            queryParams += 'id[]=' + arrayItem + '&';
        });
        return this.api.get('artists?' + queryParams);
    }
    public getArtists(label) {
        return this.api.get('artists/all?label=' + label);
    }

    public getTracks(id: number) {
        return this.api.get('artists/get-songs/?id=' + id);
    }

    public fetchSongs(artist: any) {
        return this.getTracks(artist.id);
    }
}



// WEBPACK FOOTER //
// ./src/app/api/services/artists.service.ts